module.exports = __webpack_public_path__ + "static/img/qrcode.a58b8ea0.png";